import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ReactGA from 'react-ga';
import ServicesHome from '../components/dashboard/ServicesHome';
import SurveyHome from '../components/dashboard/SurveyHome';
import { apiServices } from '../services/apiServices';
import Loader from '../components/loaders/loader';
import moment from 'moment';
import swal from "sweetalert";
class DashBoard extends Component {

	constructor(props){
		super(props);

		this.state = {
			bBoth : false,
			bOnlyService:false,
			bOnlySurvey:false,
			activeTab:"1",
			isLoading:false,
			serviceData:{},
			totalServices:0,
			surveyData:{},
			totalSurveys:0,
			todaysSurveys:0
		}
	}

    componentDidMount = async () => {
		ReactGA.pageview(window.location.pathname + window.location.search);
		let bOnlyService = false,bOnlySurvey = false,bBoth = false,isLoading = true ,
		oJsStorage = JSON.parse(localStorage.getItem('community')),
		aCommunityPrefrences = oJsStorage.community.communityPreferenceses,
		sUUID = oJsStorage.community.uuid/*,
		i = 0,nPrefLen = aCommunityPrefrences.length */;
		/* for( i = 0;i < nPrefLen;i++){
			bOnlyService = (bOnlyService || aCommunityPrefrences[i].type === 'Service');
			bOnlySurvey = (bOnlySurvey || aCommunityPrefrences[i].type === 'Survey');
			
		}

		bBoth = (bOnlyService && bOnlySurvey);	
		this.setState({bBoth,bOnlyService,bOnlySurvey,isLoading});
		 */
		/* if(bOnlyService){
			let oServiceRequest = {
				"uuid":sUUID,
				"types":["ALERT","APPOINTMENT"],
				"statusList":["9","10","11","12","33"],
				"caseSetAttrFlag":true,
				"country":null
			},
			oServiceResponse = await apiServices.loadAnalysisData(oServiceRequest),
				aServiceArr = oServiceResponse.caseSetTO_Attributes_analysis;

			this.computeServiceData(aServiceArr);
		}
		if(bOnlySurvey){
			let oSurveyRequest = {
				"uuid":sUUID,
				"types":["SURVEY"],
				"activeYN":"Y","deleteYN":"N",
				"caseSetAttrFlag":true
			},
			oSurveyResponse = await apiServices.loadAnalysisData(oSurveyRequest),
				aSurveyArr = oSurveyResponse.caseSetTO_Attributes_analysis;
			this.computeSurveyData(aSurveyArr);
		} */
		/* API Call Which will return all data */
		this.setState({isLoading});
		let oSurveyRequest = {
			uuid:sUUID
			// uuid:'81f07a2f7e176e0c0df17bffb4250ca1'
			// uuid:'c979fc3f7e196c8795095e50a9358fc9'
			// uuid:'e2d9ec7ede81eb8b5a7dd66d24a3d0aa'
		},oSurveyResponse;
		try{
			oSurveyResponse = await apiServices.loadDashboardData(oSurveyRequest);
			bOnlyService = oSurveyResponse.service.totalCases * 1 > 0
			bOnlySurvey = oSurveyResponse.survey.totalCases * 1 > 0
			bBoth = (bOnlyService && bOnlySurvey);
			
			if(bOnlyService){
				this.computeServiceData(oSurveyResponse.service);
			}
			if(bOnlySurvey){
				this.computeSurveyData(oSurveyResponse.survey);
			}

			// console.log(oSurveyResponse);
			
			/*  */
			this.setState({bBoth,bOnlyService, bOnlySurvey,isLoading:false});

			if(!(bBoth || bOnlyService || bOnlySurvey)){
				swal({
					title: "Data currently unavailable!",
					text: "Please configure your community and start with the data collection from the Imonitor+ Pro app",
					icon: "info",
					button: "OK"
				});
			}

		}catch(err){
			swal({
                title: "Error in fetching Data!!!",
                text: "Contact you Administrator.",
                icon: "error",
                button: "OK"
            });
		}
		
		
    }

  	toggle = (tab) =>  {
	    if (this.state.activeTab !== tab) {
	      this.setState({
	        activeTab: tab
	      });
	    }
	}
	  
	computeServiceData = (p_data)=>{
		let nTotalCases = p_data.totalCases * 1 ? p_data.totalCases * 1 : 0,
			nOpenCases = p_data.openCases ? p_data.openCases : 0,
			nResolvedCases = p_data.resolvedCases ? p_data.resolvedCases : 0,
			nDeclinedCases = p_data.rejectedCases ? p_data.rejectedCases : 0,
			nApprovedCases = p_data.fixedCases ? p_data.fixedCases : 0,
			oStatus = {9 : nOpenCases * 1, 10 : nApprovedCases * 1, 11 : nDeclinedCases * 1, 12: nResolvedCases * 1},
			oDates = p_data.serviceDateSummary,oDatesFormated = {},oServices = p_data.serviceNameSummary;

		for(let i in oDates){
			let sTemp = moment(i,'DD-MM-YYYY').format('DD-MMM-YY'); 
			oDatesFormated[sTemp] = oDates[i];
		}

		this.setState({
			serviceData:{status:oStatus,dates:oDatesFormated,services:oServices},
			totalServices:nTotalCases
		});
	}
	  
	computeSurveyData = (p_data)=>{
		let oGender = p_data.applicantGenderSummary,oDates = p_data.surveyDateSummary,oSurveys = p_data.surveyNameSummary,
			nSurveys = p_data.totalCases,nTodays = p_data.todaysCases,oDatesFormated = {};


		for(let i in oDates){
			let sTemp = moment(i,'DD-MM-YYYY').format('DD-MMM-YY'); 
			oDatesFormated[sTemp] = oDates[i];
		}

		this.setState({
			surveyData:{gender:oGender,dates:oDatesFormated,surveys:oSurveys},
			totalSurveys:nSurveys,
			todaysSurveys:nTodays
		});
		
	}

  	/* computeServiceData = (p_data) =>{
  		let nServices = p_data.length,
  			i = 0,oStatus = {},oDates = {},oService = {};

		for(i = 0;i < nServices;i++){
			let nStatus = p_data[i].status,
				sDate = moment(p_data[i].createdAt).format('DD-MMM-YY');
			oStatus[nStatus] = (oStatus[nStatus] || 0) + 1;
			oDates[sDate] = (oDates[sDate] || 0) + 1;
			if(p_data[i].communityPreferencesByCaseType.type === 'Service'){
				let sServ = p_data[i].communityPreferencesByCaseType.code;
				oService[sServ] = (oService[sServ] || 0) + 1;
			}

		}

		this.setState({
			serviceData:{status:oStatus,dates:oDates,services:oService},
			totalServices:nServices
		})
  	} */

  

  	/* computeSurveyData = (p_data) =>{
  		let i,nSurveys = p_data.length,
  			oGender = {},oSurveys = {},oDates = {};

		for(i = 0;i < nSurveys;i++){
			let sGender = p_data[i].applicant.gender ? p_data[i].applicant.gender.toLowerCase() : 'others',
				sDate = moment(p_data[i].createdAt).format('DD-MMM-YY');
		
			sGender = (sGender === 'male' || sGender === 'female') ? sGender  : 'others';
			oGender[sGender] = (oGender[sGender] || 0) + 1;				
			oDates[sDate] = (oDates[sDate] || 0) + 1;
			if(p_data[i].communityPreferencesByCaseType.code){
				let sSurvey = p_data[i].communityPreferencesByCaseType.code;
				oSurveys[sSurvey] = (oSurveys[sSurvey] || 0) + 1;
			}
		}

		this.setState({
			surveyData:{gender:oGender,dates:oDates,surveys:oSurveys},
			totalSurveys:nSurveys
		});

  	} */

    render() {
        return (
        	<div>
        		<Loader isLoading={this.state.isLoading}/>
        		{
        			this.state.bBoth ? 
		            <div className='container-fluid my-4'>
						<Nav tabs>
				          <NavItem>
				            <NavLink
				              className={classnames({ active: this.state.activeTab === '1' })}
				              onClick={() => { this.toggle('1'); }}
				            >
				              Services
				            </NavLink>
				          </NavItem>
				          <NavItem>
				            <NavLink
				              className={classnames({ active: this.state.activeTab === '2' })}
				              onClick={() => { this.toggle('2'); }}
				            >
				              Surveys
				            </NavLink>
				          </NavItem>
				        </Nav>
				        <TabContent activeTab={this.state.activeTab}>
				          	<TabPane tabId="1">
				            	<ServicesHome data={this.state.serviceData}
				            		total={this.state.totalServices}
				            	/>
				          	</TabPane>
				          	<TabPane tabId="2">
					           	<SurveyHome	
									data={this.state.surveyData}
									total={this.state.totalSurveys}
									todaysSurveys={this.state.todaysSurveys}
					           	/>
				          	</TabPane>
				        </TabContent>
					</div> 
					:
					this.state.bOnlyService ? 
					<ServicesHome data={this.state.serviceData}
						total={this.state.totalServices}
					/> 
					: 
					this.state.bOnlySurvey ? 
					<SurveyHome 
						data={this.state.surveyData}
						total={this.state.totalSurveys}
						todaysSurveys={this.state.todaysSurveys}
					/>
					:
					<div className="row my-4">
						<div className="col-md-11 mx-auto">
							<div className="alert alert-danger text-center" role="alert">
								<h3>
									Please click on Setup button to configure your own community and get started with the data collection from the Imonitor+ Pro mobile app
								</h3>
							</div>
						</div>	 
					</div>
        		}
        	</div>
        	
        );
    }
}

export default DashBoard;